import { createIcon } from '@chakra-ui/react';

export const Alarm = createIcon({
  displayName: 'Alarm',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5 22H5.5C3.567 22 2 20.433 2 18.5V5.5C2 3.567 3.567 2 5.5 2H18.5C20.433 2 22 3.567 22 5.5V18.5C22 20.433 20.433 22 18.5 22ZM5.5 3C4.119 3 3 4.119 3 5.5V18.5C3 19.881 4.119 21 5.5 21H18.5C19.881 21 21 19.881 21 18.5V5.5C21 4.119 19.881 3 18.5 3H5.5ZM12 8C9.791 8 8 9.791 8 12C8 14.209 9.791 16 12 16C14.209 16 16 14.209 16 12C16 9.791 14.209 8 12 8ZM12 15C10.343 15 9 13.657 9 12C9 10.343 10.343 9 12 9C13.657 9 15 10.343 15 12C15 13.657 13.657 15 12 15Z"
    />
  ),
});
